import React from "react";
import { useEffect, useRef, useState } from "react";
import Helmet from "react-helmet";


interface TurnstileWidgetProps {
  siteKey: string;
}

const TurnstileWidget: React.FC<TurnstileWidgetProps> = ({ siteKey }) => {
  const widgetRef = useRef<HTMLDivElement>(null);
  const [token, setToken] = useState("");
  const widgetIdRef = useRef<string | null>(null);
  const hasRenderedRef = useRef(false);

  useEffect(() => {
    const renderTurnstile = () => {
      // Prevent double rendering
      if (!widgetRef.current || !siteKey || hasRenderedRef.current || widgetIdRef.current) {
        return;
      }

      if (window.turnstile) {
        try {
          const widgetId = window.turnstile.render(widgetRef.current, {
            sitekey: siteKey,
            callback: (responseToken: string) => {
              setToken(responseToken);
            },
            "expired-callback": () => {
              setToken("");
            },
            "error-callback": (error: any) => {
              console.error("Turnstile error:", error);
            },
          });
          widgetIdRef.current = widgetId;
          hasRenderedRef.current = true;
        } catch (error) {
          console.error("Error rendering Turnstile:", error);
        }
      }
    };

    if (window.turnstile) {
      renderTurnstile();
    } else {
      window.onTurnstileLoad = renderTurnstile;
    }

    // Cleanup function to remove widget on unmount
    return () => {
      if (widgetIdRef.current && window.turnstile) {
        try {
          window.turnstile.remove(widgetIdRef.current);
        } catch (e) {
          console.error("Error removing Turnstile widget:", e);
        }
      }
      hasRenderedRef.current = false;
      widgetIdRef.current = null;
    };
  }, [siteKey]);

  return (
    <>
      <Helmet>
        <script
          src="https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onTurnstileLoad"
          async
          defer
        />
      </Helmet>
      <input type="hidden" id="turnstileSiteKey" name="turnstileSiteKey" value={siteKey} />
      <div ref={widgetRef} className="cf-turnstile" ></div>
      <input type="hidden" id="turnstile-token" name="cf-turnstile-response" value={token} />
      <div id="turnstile-error" style={{ display: "none", color: "red" }}>
        CAPTCHA expired. Please try again.
      </div>
    </>
  );
};

export default TurnstileWidget;